import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { actions } from 'store';
import { GroupDelete, GroupIntegrations, GroupSettings } from '.';

const GroupManage = connect((state) => ({
  pageState: state.pageState
}))(
  class extends Component {
    updateGroup = async () => {
      const {
        dispatch,
        pageState: { group }
      } = this.props;
      const groups = await api.get(`/admin/groups?id=${group.id}`);
      dispatch(
        actions.updatePageState({
          group: groups.data.groups[0]
        })
      );
    };

    render() {
      return (
        <div className="manage">
          <div>
            <GroupSettings updateGroup={this.updateGroup} />
          </div>

          <div style={{ marginTop: 40 }}>
            <GroupIntegrations />
          </div>

          <div style={{ marginTop: 40 }}>
            <GroupDelete />
          </div>
        </div>
      );
    }
  }
);

export default GroupManage;
